<template>
  <Modal :btns="[]" wrapClassName="no-border">
    <template #title>
      <div class="flex justify-between items-center title-wrapper">
        <span class="title">{{ isAddMode ? '调整项目权限' : props.title }}</span>
        <Input v-if="!isAddMode" class="search-input" placeholder="搜索成员">
        <template #prefix>
          <search-outlined class="certain-category-icon" />
        </template>
        </Input>
      </div>
    </template>
    <template v-if="!isAddMode">
      <div class="manage-body">

        <div v-for="s in selected" :key="s.key" class="manage-item">
          <div class="manage-left">
            <div class="left-avatar"></div>
            <div class="left-name">{{ s.name }}</div>
          </div>


          <div class="manage-right">
            <a-dropdown :trigger="['click']" :overlayClassName="'right-dropdown'" placement="bottomRight">
              <div :class="s.permission !== '拥有者' ? 'right-name' : 'right-first'">{{ s.permission }}</div>
              <template #overlay>
                <a-menu>
                  <a-menu-item key="0">
                    <template #icon>
                      <CheckOutlined></CheckOutlined>
                    </template>
                    <div class="operate-name">可管理（可删除、编辑、下载、移动）</div>
                  </a-menu-item>
                  <a-menu-item key="1">
                    <div class="operate-name">可编辑（可编辑、下载、移动）</div>
                  </a-menu-item>
                  <a-menu-item key="2">
                    <div class="operate-name">可查看（仅支持在线浏览）</div>
                  </a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>
            <div class="right-icon" v-show="s.permission !== '拥有者'">▾</div>

          </div>


        </div>
      </div>
    </template>
    <template v-else>
      <div class="flex add-body">
        <div class="tree">
          <Input class="search-input" placeholder="搜索成员">
          <template #prefix>
            <search-outlined class="certain-category-icon" />
          </template>
          </Input>
          <Tree checkable :selectable="false" default-expand-all :tree-data="treeData" :checked-keys="checkedKeys"
            @check="handleCheck"></Tree>
        </div>
        <div class="selected">
          <div class="selected-top">
            <div class="top-left">已选人员</div>
            <div class="top-right">全部清除</div>
          </div>
          <div v-for="s in selecteds" :key="s.key" class="manage-item">
            <div class="manage-left">
              <div class="left-avatar"></div>
              <div class="left-name">{{ s.name }}</div>
            </div>


            <div class="manage-right">
              <a-dropdown :trigger="['click']" :overlayClassName="'right-dropdown'" placement="bottomRight">
                <div :class="s.permission !== '拥有者' ? 'right-name' : 'right-first'">{{ s.permission }}</div>
                <template #overlay>
                  <a-menu>
                    <a-menu-item key="0">
                      <div class="operate-name">可管理（可删除、编辑、下载、移动）</div>
                    </a-menu-item>
                    <a-menu-item key="1">
                      <div class="operate-name">可编辑（可编辑、下载、移动）</div>
                    </a-menu-item>
                    <a-menu-item key="2">
                      <div class="operate-name">可查看（仅支持在线浏览）</div>
                    </a-menu-item>
                  </a-menu>
                </template>
              </a-dropdown>
              <div class="right-icon" v-show="s.permission !== '拥有者'">▾</div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { Input, Tree, type TreeProps } from 'ant-design-vue'
import { CheckOutlined, SearchOutlined } from '@ant-design/icons-vue'
import { Modal } from '@elecmap/elecmap-ui'
import { computed, ref, useAttrs, watch } from 'vue'

const isAddMode = ref(true)

const props = defineProps<{
  title?: string
}>()

const modalBtns = computed<any[]>(() => {
  return !isAddMode.value
    ? [
      {
        type: 'link',
        text: '+添加成员',
        onClick: () => (isAddMode.value = true),
      },
    ]
    : [
      {
        type: 'primary',
        text: '确定',
        onClick: () => (isAddMode.value = false),
      },
      {
        type: 'default',
        text: '关闭',
        onClick: () => (isAddMode.value = false),
      },
    ]
})

const selected = ref<any[]>([{ id: '1', name: 'chenxiang', permission: '拥有者' }, { id: '2', name: 'zhangsan', permission: '可管理' }, { id: '2', name: 'lisi', permission: '可编辑' }, { id: '3', name: 'wangwu', permission: '可查看' }])
const selecteds = ref<any[]>([{ id: '2', name: 'zhangsan', permission: '可管理' }, { id: '2', name: 'lisi', permission: '可编辑' }, { id: '3', name: 'wangwu', permission: '可查看' }])
const checkedKeys = computed(() => selected.value.map(item => item.key))

const handleCheck: TreeProps['onCheck'] = (keys, e) => {
  selected.value = e.checkedNodes
}

const treeData: TreeProps['treeData'] = [
  {
    title: 'parent 1',
    key: '0-0',
    checkable: false,
    children: [
      {
        title: 'leaf4',
        key: '0-0-0',
      },
      { title: 'leaf1', key: '0-0-0-0' },
      { title: 'leaf2', key: '0-0-0-1' },
    ],
  },
  {
    title: 'parent 2',
    key: '2',
    checkable: false,
    children: [{ key: '2-1', title: 'leaf3' }],
  },
]


</script>

<style lang="less" scoped>
.title {
  font-size: 15px;
}

.title-wrapper {
  padding-right: 40px;
  height: 32px;

  .search-input {
    width: 200px;
    border-radius: 20px;
    background-color: #fbfbfb;

    :deep(.ant-input) {
      background-color: #fbfbfb;
    }
  }
}

.manage-body {
  height: 400px;

  .manage-item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;

    .manage-left {
      display: flex;
      align-items: center;

      .left-avatar {
        width: 40px;
        height: 40px;
        background-color: rgb(0, 112, 221);
        border-radius: 50%;
        margin-right: 12px;
      }

      .left-name {
        font-size: 13px;
      }
    }

    .manage-right {
      display: flex;
      align-items: center;
      cursor: pointer;

      .right-first {
        margin-right: 10px;
      }
    }
  }
}

.add-body {
  border: 1px solid #f0f0f0;
  height: 400px;

  .search-input {
    width: 200px;
    border-radius: 20px;
    background-color: #fbfbfb;
    margin: 12px 0 12px 4px;

    :deep(.ant-input) {
      background-color: #fbfbfb;
    }
  }

  >div {
    flex: 1 0 0;
  }

  >.selected {
    border-left: 1px solid #f0f0f0;
    padding: 16px;

    .selected-top {
      display: flex;
      justify-content: space-between;
      margin-top: 2px;
      margin-bottom: 20px;

      .top-left {
        font-size: 11px;
      }

      .top-right {
        font-size: 11px;
        color: rgb(0, 112, 221);
      }
    }

    .manage-item {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;

      .manage-left {
        display: flex;
        align-items: center;

        .left-avatar {
          width: 28px;
          height: 28px;
          background-color: rgb(0, 112, 221);
          border-radius: 50%;
          margin-right: 12px;
        }

        .left-name {
          font-size: 13px;
        }
      }

      .manage-right {
        display: flex;
        align-items: center;
        cursor: pointer;

        .right-first {
          margin-right: 10px;
        }
      }
    }
  }
}
</style>
